import React from 'react'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

interface INbMilesByZipProps {
  locale: 'en' | 'fr'
}

const NbMilesByZip: React.FC<INbMilesByZipProps> = ({ locale }) => {
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()

  const isAgent = isAgentLogin()
  const isCarrier = isCarrierLogin()

  const invitingCompanyId =
    isCarrier || isAgent ? ensuredInvitingCompanyId : undefined
  const carrierId = !isCarrier
    ? localStorage.getItem('carrierId') || undefined
    : undefined
  // NB reports are always in km — Canadian market uses metric regardless of locale.
  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.NB_MILES_BY_ZIP}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
      locale={locale === 'fr' ? 'fr-CA' : 'en-US'}
      distanceUnit="km"
    />
  )
}

export default NbMilesByZip
